import React, { useState, useEffect } from 'react';
import './Toast.css'; // You can customize styling here

const Toast = ({ message, duration = 3000, onClose }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (message) {
            setIsVisible(true);
            const timer = setTimeout(() => {
                setIsVisible(false);
                setTimeout(() => {
                    if (onClose) onClose();
                }, 300); // Wait for animation to complete
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [message, duration, onClose]);

    if (!message) return null;

    return (
        <div className={`toast-notification ${isVisible ? 'show' : 'hide'}`}>
            {message}
        </div>
    );
};

// Toast Hook for easy usage
export const useToast = () => {
    const [toast, setToast] = useState('');

    const showToast = (message, duration = 3000) => {
        setToast(message);
        setTimeout(() => setToast(''), duration);
    };

    const hideToast = () => {
        setToast('');
    };

    return {
        toast,
        showToast,
        hideToast,
        ToastComponent: () => (
            <Toast 
                message={toast} 
                onClose={hideToast}
            />
        )
    };
};

export default Toast;
